import service, {
  PandoResponse,
} from '@customer/services/pandoService/service';

const deleteEmergencyContact = async (
  {
    accountGuid,
    emergencyContactId,
  }: {
    accountGuid: string;
    emergencyContactId: number;
  },
  { accessToken }: { accessToken: string }
) => {
  const response = service.delete<PandoResponse<{}>>(
    `/api/deleteEmergencyContact`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        AccountGuid: accountGuid,
        EmergencyContactId: emergencyContactId,
      },
    }
  );
  return response;
};

export default deleteEmergencyContact;
